var Wallop = require("wallop");
var anime = require("animejs/lib/anime.js");
var Equalizer = require("equalizer");
var PubSub = require("underpub-js");

var heroBgImagesWithLinks = function(options) {
  this.options = {
    $el: false,
  };

  $.extend(true, this.options, options);
};

heroBgImagesWithLinks.prototype.init = function() {
  var self = this;

  var imagesSlider = this.options.$el.find(".images-slider")[0]; // wallop takes a plain JS element, so use [0]
  var imagesWallop = new Wallop(imagesSlider);

  this.slideCount = this.options.$el.data("slideCount");

  var slideChange = function(event) {
    var activeSlideNum = event.detail.currentItemIndex;
    self.updateSlideCounter(activeSlideNum + 1);
  };

  imagesWallop.on("change", slideChange);

  if (this.slideCount > 1) {
    window.setInterval(function() {
      self.animateSlideTransition();
      imagesWallop.next();
    }, 8000);
  }

  // equalize slide heights
  var equalHeightItems = this.options.$el[0].querySelectorAll(
    ".text-content-slider .text-slide",
  );
  this.eq = new Equalizer(equalHeightItems);
  this.eq.align();

  PubSub.subscribe("resized", function() {
    self.eq.align();
  });
};

heroBgImagesWithLinks.prototype.animateSlideTransition = function() {
  // var animeTimeline = anime.timeline();
  // var animationSpeed = 450;
  // var startingOffset = 500;
  // var incrementOffset = 200;
  //
  // animeTimeline
  // // fade out text
  // .add({
  //   targets: [headings, ctas],
  //   opacity: 0,
  //   duration: 300,
  //   easing: window.easings.ease
  // }, 0)
  // // move text down while hidden
  // .add({
  //   targets: [headings, ctas],
  //   translateY: 20,
  //   duration: 1,
  //   easing: 'linear'
  // }, 301)
  // // animate move heading up
  // .add({
  //   targets: [headings],
  //   translateY: 0,
  //   duration: animationSpeed,
  //   easing: window.easings.ease
  // }, startingOffset)
  // // animate fade heading in
  // .add({
  //   targets: [headings],
  //   opacity: 1,
  //   duration: animationSpeed,
  //   easing: window.easings.ease
  // }, startingOffset)
  // // animate move cta up
  // .add({
  //   targets: [ctas],
  //   opacity: 1,
  //   translateY: 0,
  //   duration: animationSpeed,
  //   easing: window.easings.ease
  // }, startingOffset + (1 * incrementOffset))
  // // animate fade cta in
  // .add({
  //   targets: [ctas],
  //   opacity: 1,
  //   duration: animationSpeed,
  //   easing: window.easings.ease
  // }, startingOffset + (1 * incrementOffset));
};

heroBgImagesWithLinks.prototype.updateSlideCounter = function(slideNumber) {
  var self = this;

  var $currentSlideNum = this.options.$el.find(
    ".slide-counter .active-slide-number .current-slide-num",
  );
  var $nextSlideNum = this.options.$el.find(
    ".slide-counter .active-slide-number .next-slide-num",
  );

  $nextSlideNum.html(slideNumber);

  $currentSlideNum.removeClass("current-slide-num").addClass("old-slide-num");

  $nextSlideNum.removeClass("next-slide-num").addClass("current-slide-num");

  window.setTimeout(function() {
    self.options.$el
      .find(".old-slide-num")
      .removeClass("old-slide-num")
      .addClass("next-slide-num");
  }, 1000);
};

module.exports = heroBgImagesWithLinks;
